export default [
  {
    iconName: 'benefits-journeys',
    title: 'main.benefits.titles.0',
    text: 'main.benefits.tooltips.0',
  },
  {
    iconName: 'benefits-fast',
    title: 'main.benefits.titles.1',
    text: 'main.benefits.tooltips.1',
  },
  {
    iconName: 'benefits-flexible',
    title: 'main.benefits.titles.2',
    text: 'main.benefits.tooltips.2',
  },
  {
    iconName: 'benefits-operators',
    title: 'main.benefits.titles.3',
    text: 'main.benefits.tooltips.3',
  },
  {
    iconName: 'benefits-rewards',
    title: 'main.benefits.titles.4',
    text: 'main.benefits.tooltips.4',
  },
];
